import * as THREE from 'three'

/**
 * 封装第三人称类
 */
export class CharacterControls{


	constructor(player,mixer,animationsMap,orbitControl,camera,currentAction, collideObjects){

		this.raycaster = new THREE.Raycaster();//碰撞检查
		this.collideObjects = collideObjects;//碰撞检查物体

		this.model = player
		this.mixer = mixer
		this.animationsMap = animationsMap
		this.currentAction = currentAction
		this.animationsMap.forEach((value, key) => {
			//key Idle Run Walk
			// console.log("currentAction:"+currentAction)
			if (key == currentAction) {
				value.play()
			}
		})
		this.animationsMap.get(currentAction).play();
		this.orbitControl = orbitControl
		this.camera = camera

		this.x = 0;
		this.z = 0;


		this.toggleRun = true
		// temporary data
		this.walkDirection = new THREE.Vector3()
		//旋转的轴 y轴
		this.rotateAngle = new THREE.Vector3(0, 1, 0)
		//四元数
		this.rotateQuarternion= new THREE.Quaternion()
		this.cameraTarget = new THREE.Vector3()
		//动作切换时间
		this.fadeDuration = 0.2
		//跑步速度
		this.runVelocity = 500
		//走路速度w
		this.walkVelocity = 200
		this.DIRECTIONS = ['w', 'a', 's', 'd']


		this.updateCameraTarget(0,0)

	}

	updateCameraTarget(moveX, moveZ) {
		//移动相机
		this.camera.position.x += moveX
		this.camera.position.z += moveZ

		// 更新相机的target
		this.cameraTarget.x = this.model.position.x
		this.cameraTarget.y = this.model.position.y + 1
		this.cameraTarget.z = this.model.position.z
		this.orbitControl.target = this.cameraTarget
	}

	switchRunToggle() {
		this.toggleRun = !this.toggleRun
	}

	/**
	 * 计算wasd这4个按键后的旋转角度
	 * 计算规则：向前w 角度0    		w+a 逆时针45°   w+d 顺时针45°
	 * 			向后s 角度逆时针180° 	s+a 逆时针135°  s+d 顺时针135°
	 * 			向左a 逆时针90°
	 * 			向右d 顺时针90°
	 * @param keysPressed
	 */
	directionOffset(keysPressed){
		var directionOffset = 0 // w
		if(keysPressed['w']){
			if(keysPressed['a']){
				directionOffset =Math.PI/4
			}else if(keysPressed['d']){
				directionOffset =-Math.PI/4
			}
		}else if(keysPressed['s']){
			if(keysPressed['a']){
				directionOffset = Math.PI / 4 + Math.PI / 2
			}else if(keysPressed['d']){
				directionOffset = -Math.PI / 4 - Math.PI / 2
			}else{
				directionOffset = Math.PI
			}
		}else if(keysPressed['a']){
			directionOffset = Math.PI / 2
		}else if(keysPressed['d']){
			directionOffset = -Math.PI / 2
		}
		return directionOffset;
	}


	//动作更新
	update(delta,keysPressed){

		//directionPressed 判断是否按下设定好的按键， 有的话为true
    	const directionPressed = this.DIRECTIONS.some(key => keysPressed[key] == true)
		var play = '';
		//如果按下 wasd这几个按键， 就改成走路或者跑步状态，否者就是停止状态
		if (directionPressed && this.toggleRun) {
			play = 'run'
		} else if (directionPressed) {
			play = 'walk'
		} else {
			play = 'idle'
		}
		//如果当前不是运动状态，就切换动画
		if (this.currentAction != play) {
			const toPlay = this.animationsMap.get(play)
			const current = this.animationsMap.get(this.currentAction)
			current.fadeOut(this.fadeDuration)
			toPlay.reset().fadeIn(this.fadeDuration).play();
			this.currentAction = play
		}

		this.mixer.update(delta)
		//计算运动的时候转向的角度
		if(this.currentAction =='run' || this.currentAction =='walk'){
			//1: 先计算 相机和机器人的夹角
			var angleYCameraDirection = Math.atan2( (this.camera.position.x - this.x), (this.camera.position.z - this.z))
			//2:然后计算 wasd按键后的旋转角度，写个函数来计算
			var directionOffset = this.directionOffset(keysPressed)
			// rotate model 旋转模型,算出四元数旋转的角度，然后旋转模型
			// 从由 axis（轴） 和 angle（角度）所给定的旋转来设置该四元数。改编自 here 所述的方法。假定Axis已被归一化，angle以弧度来表示。
			this.fromAxisAngle = angleYCameraDirection + directionOffset;
			this.rotateQuarternion.setFromAxisAngle(this.rotateAngle, this.fromAxisAngle)
			
			//计算机器人旋转起来
			// q - 目标四元数 step - 以弧度为单位的角度步长
			this.model.quaternion.rotateTowards(this.rotateQuarternion, 0.2)

			//碰撞检测
			let result = this.frontCheckCollide(this.model)
			if(result){
				return;
			}

			//3. 让机器人和相机移动
			this.camera.getWorldDirection(this.walkDirection)
			this.walkDirection.y = 0
			this.walkDirection.normalize()
			// axis - 一个被归一化的Vector3。angle - 以弧度表示的角度。
			this.walkDirection.applyAxisAngle(this.rotateAngle, directionOffset)
			//velocity为机器人速度
			const velocity = this.currentAction == 'Run' ? this.runVelocity : this.walkVelocity

			let moveX = 0;
			let moveZ = 0;
			var leftObj = this.angleCheckCollide(this.model, Math.PI / 4)
			if(leftObj){
				return;
			}else{
				moveX = this.walkDirection.x * velocity * delta
			}
			var rightObj = this.angleCheckCollide(this.model, -Math.PI / 4);
			if(rightObj){
				return;
			}else{
				moveZ = this.walkDirection.z * velocity * delta
			}
			// console.log(moveX, moveZ)
			//移动机器人
			this.x += moveX
			this.model.position.x = this.x;
			this.z += moveZ
			this.model.position.z = this.z;
			//相机更新位置
			this.updateCameraTarget(moveX, moveZ)
		}
	}

    /**
     * 角色碰撞检测【前】
     * @param {Object3D} target 需要碰撞检测的移动物体
     * @returns Boolean
     */
    frontCheckCollide(target) {
		// 获取target当前位置，Y轴加一个固定量，代表纵轴射线发射（检测碰撞的）位置
		let origin = target.position.clone().add(new THREE.Vector3(0, 10, 0));
		// 获取target当前朝向
		let direction = new THREE.Vector3(); //定义一个方向向量
		target.getWorldDirection(direction);
		direction.normalize();
		direction.negate();
		return this.checkCollide('front', this.raycaster, origin, direction);
    }
	/**
     * 角色碰撞检测【角度】
     * @param {Object3D} target 需要碰撞检测的移动物体
     * @returns Boolean
     */
    angleCheckCollide(target, angle, intersectDistance) {
		// 获取target当前位置，Y轴加一个固定量，代表纵轴射线发射（检测碰撞的）位置
		let origin = target.position.clone().add(new THREE.Vector3(0, 10, 0));
		// 获取target当前朝向
		let direction = new THREE.Vector3(); //定义一个方向向量
		target.getWorldDirection(direction);
		direction.normalize();
		direction.negate();
		var axis = new THREE.Vector3( 0, 1, 0 );
		direction.applyAxisAngle( axis, angle );
		return this.checkCollide('left', this.raycaster, origin, direction, intersectDistance);
    }

	/**
     * 角色碰撞检测【方向】
     * @param {THREE.Raycaster} raycaster 移动物体的碰撞检测射线
     * @param {THREE.Vector3} origin 射线发射（检测碰撞的）位置
     * @param {THREE.Vector3} direction 射线发射的朝向
     * @param {Number} intersectDistance 检测距离，小于此距离表示碰撞了
     * @param {Boolean} recursive 是否递归检测场景中的物体
     * @returns Boolean
	 */
	checkCollide(
		type,
		raycaster,
		origin,
		direction,
		intersectDistance = 20,
		recursive = true
	){

		// 设置射线发射位置
		raycaster.ray.origin.copy(origin);

		// 设置射线发射方向
		raycaster.ray.direction.copy(direction);

		// 开始【前】检测：对于blender制作的模型，需要递归遍历所有child，否则无法实现射线碰撞检测{[childs], true}
		let ins = raycaster.intersectObjects(this.collideObjects, recursive);
		// console.log(ins[0].point)
		if (ins.length) {
			let { distance, point, object } = ins[0];
			// if (object.name == "stair") {//梯子
			//   return false;
			// }
			if (distance < intersectDistance) {
				// if(type != 'front'){
				// 	console.warn(type+"💥碰撞了:", distance);
				// }
				return {point: point};
			}
		}
		return false;
	}



}



// WEBPACK FOOTER //
// ./src/assets/js/CharacterControls.js